import AdSlot from "@/components/site/AdSlot";
import OwnerLeadForm from "@/components/site/OwnerLeadForm";
import Seo from "@/components/site/Seo";
import { useSite } from "@/lib/site";

export function Services() {
  return (
    <div className="container-x py-14 space-y-10" data-testid="services-page">
      <Seo title="Directorio de servicios para mudarte a Punta Cana" description="Mudanzas, limpieza, muebles, aire acondicionado, internet y más proveedores en Punta Cana." />
      <div className="space-y-3 max-w-2xl"><p className="eyebrow">Directorio</p><h1 className="text-3xl sm:text-4xl font-extrabold">Servicios recomendados</h1>
        <p className="text-slate-600">Proveedores para tu mudanza y tu hogar. Todos los anuncios están identificados como patrocinados.</p></div>
      <AdSlot placement="directorio" testid="directory-ads" />
      <AdSlot placement="ficha_patrocinada" emptyText={false} testid="sponsored-ads" />
    </div>
  );
}

export function PublishProperty() {
  const { settings: s } = useSite();
  return (
    <div className="container-x py-14 grid lg:grid-cols-2 gap-12" data-testid="publish-page">
      <Seo title="Publica tu propiedad en alquiler en Punta Cana" description="¿Tienes una propiedad en Punta Cana? Publícala con SoloRentaPC y encuentra inquilinos de largo plazo." />
      <div className="space-y-6">
        <p className="eyebrow">Propietarios</p>
        <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight">{s.owners_title || "¿Tienes una propiedad para alquilar?"}</h1>
        <p className="text-slate-600 leading-relaxed">{s.owners_text}</p>
        <img src="/images/publish.jpg" alt="Propiedad con piscina en Punta Cana" className="rounded-3xl aspect-[4/3] w-full object-cover" data-testid="publish-page-photo" />
      </div>
      <div className="rounded-3xl bg-white border border-slate-200 p-7 sm:p-10 shadow-sm h-fit"><OwnerLeadForm /></div>
    </div>
  );
}

export function Legal() {
  const { settings: s } = useSite();
  return (
    <div className="container-x py-14 max-w-3xl space-y-8" data-testid="legal-page">
      <Seo title="Privacidad y términos" />
      <h1 className="text-3xl font-extrabold">Privacidad y términos</h1>
      <section className="space-y-2"><h2 className="text-xl font-bold">Política de privacidad</h2><p className="text-slate-600 whitespace-pre-line">{s.legal_privacy}</p></section>
      <section className="space-y-2"><h2 className="text-xl font-bold">Términos de uso</h2><p className="text-slate-600 whitespace-pre-line">{s.legal_terms}</p></section>
    </div>
  );
}
